<template>
  <div class="container">
    <div class="card">
      <h2>Программируемый метроном</h2>
    </div>
    <div class="card">
      <button class="btn mobile primary" @click.prevent="save">
        Сохранить
      </button>
      <button class="btn mobile danger" @click.prevent="load(true)">
        Загрузить
      </button>
    </div>
    <ul class="list" v-for="block in blockList" :key="block.id">
      <app-metronom
        :timeSiz="+block.timeSize"
        :temp="+block.tempo"
        :tacts="+block.tacts"
        :wholeVol="+block.wholeVol"
        :doubleVol="+block.doubleVol"
        :tripleVol="+block.tripleVol"
        :quartVol="+block.quartVol"
        :eightVol="+block.eightVol"
        :sixteenVol="+block.sixteenVol"
        :FwholeSkip="+block.FwholeSkip"
        :FdoubleSkip="+block.FdoubleSkip"
        :FtripleSkip="+block.FtripleSkip"
        :FquartSkip="+block.FquartSkip"
        :FeightSkip="+block.FeightSkip"
        :FsixteenSkip="+block.FsixteenSkip"
        :wholeWeak="block.wholeWeak"
        :doubleWeak="block.doubleWeak"
        :tripleWeak="block.tripleWeak"
        :quartWeak="block.quartWeak"
        :eightWeak="block.eightWeak"
        :sixteenWeak="block.sixteenWeak"
        :id="block.id"
        @delete="deleteById"
        @stopped="goToNextMetronom"
        ref="metronome"
      >
      </app-metronom>
    </ul>
    <div class="card nocol">
      <button
        class="btn mobile primary"
        v-if="blockList.length > 1"
        @click.prevent="startAll"
      >
        Старт по очереди
      </button>
      <div v-if="blockList.length > 1">
        <svg class="svg-big" @click.prevent="startAllTime">
          <title id="startAllId">Старт всех одновременно</title>
          <use xlink:href="./img/symbol-defs.svg#icon-play2"></use>
        </svg>
        <svg class="svg-big red" @click.prevent="stopAllTime">
          <title id="startAllId">Стоп всех</title>
          <use xlink:href="./img/symbol-defs.svg#icon-stop"></use>
        </svg>
      </div>
      <button class="btn mobile" @click.prevent="addNewBlock">
        Добавить новый блок
      </button>
    </div>
    <p>От барабанщика - всем музыкантам =)</p>
    <a href="https://vk.com/konditer41" target="”_blank”"
      >Автор: Антон Рыбалко</a
    >
  </div>
</template>

<script>
import AppMetronom from "./components/AppMetronom.vue";
import { ref, onMounted } from "vue";

export default {
  components: { AppMetronom },
  setup() {
    const blockList = ref([]);
    const metronome = ref();
    const currentMetr = ref(-1);

    const generateId = () => {
      return Math.random().toString(16).slice(2);
    };

    onMounted(() => {
      load();

      if (!blockList.value || blockList.value.length <= 0) {
        blockList.value.push({
          id: generateId(),
          timeSize: 4,
          tempo: 120,
          tacts: 0,
          wholeVol: 100,
          doubleVol: 0,
          tripleVol: 0,
          quartVol: 50,
          eightVol: 0,
          sixteenVol: 0,
          FwholeSkip: 0,
          FdoubleSkip: 0,
          FtripleSkip: 0,
          FquartSkip: 0,
          FeightSkip: 0,
          FsixteenSkip: 0,
          wholeWeak: false,
          doubleWeak: false,
          tripleWeak: false,
          quartWeak: false,
          eightWeak: false,
          sixteenWeak: false,
        });
      }
    });

    const addNewBlock = () => {
      blockList.value.push({
        id: generateId(),
        timeSize: 4,
        tempo: 120,
        tacts: 0,
        wholeVol: 100,
        doubleVol: 0,
        tripleVol: 0,
        quartVol: 50,
        eightVol: 0,
        sixteenVol: 0,
        FwholeSkip: 0,
        FdoubleSkip: 0,
        FtripleSkip: 0,
        FquartSkip: 0,
        FeightSkip: 0,
        FsixteenSkip: 0,
        wholeWeak: false,
        doubleWeak: false,
        tripleWeak: false,
        quartWeak: false,
        eightWeak: false,
        sixteenWeak: false,
      });
    };

    const deleteById = (id) => {
      blockList.value = blockList.value.filter((item) => {
        return item.id !== id;
      });
    };

    const startAll = () => {
      for (const item of metronome.value) {
        item.clearTimer();
      }
      currentMetr.value = 0;
      metronome.value[0].toggleMetr();
    }

    const stopAllTime = () => {
      for (const item of metronome.value) {
        item.clearTimer();
      }
    }

    const startAllTime = () => {
      stopAllTime()
      for (const item of metronome.value) {
        item.toggleMetr();
      }
    }

    const goToNextMetronom = () => {
      if (currentMetr.value === -1) {
        return;
      }
      currentMetr.value += 1;
      if (currentMetr.value < metronome.value.length) {
        metronome.value[currentMetr.value].toggleMetr();
      }
    };

    const save = () => {
      const currList = [];
      for (const item of metronome.value) {
        currList.push({
          id: item.id,
          timeSize: item.timeSize,
          tempo: item.tempo,
          tacts: item.taktCount,
          wholeVol: +item.wholeVolume,
          doubleVol: +item.doubleVolume,
          tripleVol: +item.tripleVolume,
          quartVol: +item.quartVolume,
          eightVol: +item.eightVolume,
          sixteenVol: +item.sixteenVolume,
          FwholeSkip: +item.wholeSkip,
          FdoubleSkip: +item.doubleSkip,
          FtripleSkip: +item.tripleSkip,
          FquartSkip: +item.quartSkip,
          FeightSkip: +item.eightSkip,
          FsixteenSkip: +item.sixteenSkip,
          wholeWeak: item.wholeSkipWeak,
          doubleWeak: item.doubleSkipWeak,
          tripleWeak: item.tripleSkipWeak,
          quartWeak: item.quartSkipWeak,
          eightWeak: item.eightSkipWeak,
          sixteenWeak: item.sixteenSkipWeak,
        });
      }
      const parsed = JSON.stringify(currList);
      localStorage.setItem("metronome-list", parsed);
    };
    const load = (stopApp) => {
      if (stopApp) {
        for (const item of metronome.value) {
          item.clearTimer();
        }
      }

      const main = localStorage.getItem("metronome-list");
      const parsed = JSON.parse(main);
      blockList.value = [];
      if (parsed) {
        for (const item of parsed) {
          blockList.value.push({ ...item, id: generateId() });
        }
      }
    };

    return {
      blockList,
      addNewBlock,
      deleteById,
      startAll, startAllTime, stopAllTime,
      goToNextMetronom,
      metronome,
      save,
      load,
    };
  },
};
</script>
